import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PermissionRestrictedContainerComponent} from './permission-restricted-container.component';
import {ErrorTextModule} from "../../../../../core/component/error-text/error-text.module";

@NgModule({
    imports: [
        CommonModule,
        ErrorTextModule,
    ],
    declarations: [
        PermissionRestrictedContainerComponent,
    ],
    exports: [
        PermissionRestrictedContainerComponent,
    ]
})
export class PermissionRestrictedContainerModule {}
